import {Pipe, PipeTransform} from '@angular/core';
import {ProductDto} from '../../../Models/Purchases/Products/product.interface';
import {ProductTypesEnum} from '../../../Shared/Enum/product-types.enum';

@Pipe({
  name: 'products',
  standalone: false
})
export class ProductsPipe implements PipeTransform {

  transform(items: ProductDto[], filter: { type?: number }): ProductDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.type) {

      switch (filter.type) {
        case ProductTypesEnum.purchase:
          return items.filter((item) => item.compra);

        case ProductTypesEnum.sale:
          return items.filter((item) => item.venta);

        case ProductTypesEnum.recipe:
          return items.filter((item) => item.receta);

        case ProductTypesEnum.elaboration:
          return items.filter((item) => item.elaborado);
      }

    }

    return items;

  }

}
